import React from 'react';
import './calltoaction.css';
import { Link } from 'react-router-dom';
import homeContent from '../../../content/pages/home.json';

const CallToAction = () => {
    const { heading, text1, text2, buttonText, linkTo } = homeContent.callToAction;

    return (
        <section className='CTA-homepage'>
            <h2>{heading}</h2>
            <p className="cta-subtext">{text1}</p>
            <p className="cta-subtext">{text2}</p>
            <Link to={linkTo} className='CTA-button-homepage'>{buttonText}</Link>
        </section>
    );
}

export default CallToAction;
